<template>
  <div>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true" class id="setting-close"></span>
    </button>
    <div v-if="!permission">
      <div>
        <p>Welcome to meetbeans!</p>
        <hr>
        <div class="text-center" v-if="!allowPermissionState">
          <div style="width: 250px; height: 200px; color: #aaa; background-color: #1b1b1b; position: relative; left: 22%; margin: 15px 0">
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
                  <span style="font-size: 1.8rem">
                    <i class="fas fa-video-slash"></i>
                  </span>
                  <p style="font-size: 12px">Cam/Mic not active</p>
              </div>
          </div>
          <div>
            <p>You are about to enter into Meetbeans event.</p>
            <p style="font-size: 12px">To enjoy this event to the best you need to turn on your camera & microphone</p>
          </div>
          <button class="btn btn-primary btn-sm" @click="allowPermission">Allow camera & microphone</button>
          <br />
          <br />
          <button
            class="btn btn-outline-secondary btn-sm"
            data-dismiss="modal"
          >Join event without camera & microphone</button>
        </div>
        <div v-else>
          <div>
            <div>
              <h5>Your camera and microphone are being blocked</h5>
              <p>To join the event with your camera and microphone, follow these steps:</p>
              <ol style="font-size: 14px">
                <li>Click on the camera icon near the start on the right of the address bar.</li>
                <li>From there check "Always allow Meetbeans to access camera & microphone"</li>
                <li>Refresh this tab.</li>
              </ol>
            </div>
            <button
                class="btn btn-outline-secondary btn-sm"
                data-dismiss="modal"

                style="margin-left: 100px"
              >Join without microphone and camera</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div>
        <p>
          <b>Hey, Welcome to Meetbeans</b>
        </p>
      </div>

      <div class="text-center">
        <section id="video-preview" style="width: 250px; height: 188px; margin: 10px 100px"></section>
        <!-- <video
        id="video"
        width="250"
        height="188"
        autoplay
        style="border: 1px solid #ffe;border-radius: 16px"
        ></video>-->
      </div>
      <div class="setting">
        <div class="form-group">
          <p>Please set up & test your audio and video</p>
          <label>Select Camera</label>
          <select class="form-control" v-model="selectedCamera" required id="setting-camera">
            <option
              v-for="(item, index) in videoDeviceContainer"
              :value="item"
              :key="index"
            >{{ item }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Select Mic</label>
          <select class="form-control" v-model="selectedMic" required id="setting-mic">
            <option
              v-for="(item, index) in audioDeviceContainer"
              :value="item"
              :key="index"
              :selected="selectedMic === item"
            >{{ item }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Select Auditorium Audio</label>
          <select class="form-control" v-model="selectedAudiotoriumAudio" required id="setting-auditorium-music">
            <option
              v-for="(url, key) in auditoriumAudios"
              :value="url"
              :key="key"
            >{{ key }}</option>
          </select>
        </div>
        <!-- <div id="" style="margin:10px; width: 100%; height: 30px">
          <svg height="25" width="25" v-if="audioLevel > 0 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="green" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.1 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="green" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.2 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="green" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.3 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="green" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.4 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="yellow" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.5 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="yellow" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.55 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="yellow" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.6 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="yellow" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.65 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="red" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.7 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="red" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.75 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="red" />
          </svg>
          <svg height="25" width="25" v-if="audioLevel > 0.8 && audioLevel < 0.9">
            <circle cx="10" cy="10" r="10" stroke="black" stroke-width="1" fill="red" />
          </svg>
        </div> -->
        <div style="display: flex; justify-content: space-between">
          <div id="setting-info">
            <span class="text-primary" @click="handleFixIssue">
              <i class="fas fa-info-circle"></i>
              <a href="#" target="_blank" class="ml-1"><b>Still facing issue?</b></a>
            </span>
            <div
              class="tooltip-text"
              style="background-color: #101010; border: 1px solid; border-radius: 10px; color: #fff; font-size: 12px;"
            >
              <b>Still facing issue ?</b>
              <ul style="text-align: left;">
                <li>Please check your browser pop-up blocker, it might be blocking the camera and mic access.</li>
                <li>Meetbeans works best in Google Chrome Browser Version 58 and above. Please check your browser here <a href="https://www.whatismybrowser.com/">https://www.whatismybrowser.com/</a> </li>
                <li>If you experience video and audio lag, please check your internet connection. You can test the speed <a href="https://www.whatismybrowser.com/detect/speed-test?utm_source=whatismybrowsercom&utm_medium=internal&utm_campaign=homepage&utm_content=detect-result">here </a></li>
              </ul>
            </div>
          </div>
          <button
            type="submit"
            id="submit-setting"
            @click="submitSetting"
            class="btn btn-primary float-right"
            data-dismiss="modal"
          >Save Preference</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AgoraRTC from "agora-rtc-sdk";
export default {
  data() {
    return {
      audioDeviceContainer: [],
      videoDeviceContainer: [],
      auditoriumAudios: {
        "Default": "https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/jazz-autitorium.m4a",
        "Piano": "https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/piano.mp3",
        "None": "",
      },
      audioDeviceConfiguration: [],
      videoDeviceConfiguration: [],
      selectedCamera: "",
      selectedMic: "",
      selectedAudiotoriumAudio: "https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/jazz-autitorium.m4a",
      selectedAudiotoriumVolume: .1,
      previewStream: {},
      uid: 1000000001,
      permission: true,
      allowPermissionState: false,
      audioLevel: 0
    };
  },

  methods: {
    handleFixIssue(e) {
      e.preventDefault();
      document.getElementById("setting-close").click();
      let routeData = this.$router.resolve({name: 'fix-issues', query: {data: "setting"}});
      window.open(routeData.href, '_blank');
      this.submitSetting()
    },
    allowPermission() {
      let $ = this;
      navigator.getUserMedia(
        {
          video: true,
          audio: true
        },

        function() {
          $.permission = true;
        },

        // errorCallback
        function() {
          $.permission = false;
        }
      );
      this.allowPermissionState = true;
    },
    submitSetting() {
      const $ = this;
      
      let data = {
        selectedMic: $.selectedMic,
        selectedCamera: $.selectedCamera
      };
      const req = [
        {
          type: "",
          deviceId: ""
        },
        {
          type: "",
          deviceId: ""
        },
        {
          type: "auditoriumAudio",
          url: this.selectedAudiotoriumAudio,
          volume: this.selectedAudiotoriumVolume
        }
      ];
      $.audioDeviceConfiguration.forEach(item => {
        if (item.label === data.selectedMic) {
          req[0].type = "audio";
          req[0].deviceId = item.deviceId;
        }
      });
      $.videoDeviceConfiguration.forEach(item => {
        if (item.label === data.selectedCamera) {
          req[1].type = "video";
          req[1].deviceId = item.deviceId;
        }
      });
      const packet = {
        req: req
      };
      $.$root.$emit("handlesubmitSetting", packet);

      $.previewStream.close();
      document.getElementById(`player_${$.uid}`).remove();
    },
    showSetting: function() {
      let $ = this;
      $.allowPermissionState = false;
      $.handleDeviceSwitch();
      AgoraRTC.getDevices(function(devices) {
        var audioDevices = devices.filter(function(device) {
          return device.kind === "audioinput";
        });
        var videoDevices = devices.filter(function(device) {
          return device.kind === "videoinput";
        });

        var selectedMicrophoneId = audioDevices[0].deviceId;
        // console.log("MicrophoneId: ", selectedMicrophoneId);

        var selectedCameraId = videoDevices[0].deviceId;
        // console.log("CameraId: ", selectedCameraId);
        $.previewStream = AgoraRTC.createStream({
          streamID: $.uid,
          audio: true,
          microphoneId: selectedMicrophoneId,
          video: true,
          cameraId: selectedCameraId,
          screen: false
        });

        $.previewStream.init(
          function() {
            $.permission = true;
            $.previewStream.play("video-preview");
            $.handleDeviceSwitch();
            if (document.getElementById("video1000000001")) {

                document.getElementById("video1000000001").style.left = "0";
            }
            setInterval(() => {
              $.audioLevel = $.previewStream.getAudioLevel()
              // console.log("Audio level: ", $.previewStream.getAudioLevel());
            }, 1000)


          },
          () => {
            $.permission = false;
          }
        );
      });
    },

    handleDeviceSwitch() {
      // Get all audio and video devices
      const $ = this;
      AgoraRTC.getDevices(function(devices) {
        const audioDevices = devices.filter(function(device) {
          return device.kind === "audioinput";
        });
        $.audioDeviceConfiguration = audioDevices;
        if (audioDevices.length > 0) {
          audioDevices.forEach(item => {
            if (!$.audioDeviceContainer.includes(item.label)) {
              $.audioDeviceContainer.push(item.label);
            }
          });
          $.selectedMic = $.audioDeviceContainer[0];
        }
        const videoDevices = devices.filter(function(device) {
          return device.kind === "videoinput";
        });
        $.videoDeviceConfiguration = videoDevices;
        if (videoDevices.length > 0) {
          videoDevices.forEach(item => {
            if (!$.videoDeviceContainer.includes(item.label)) {
              $.videoDeviceContainer.push(item.label);
            }
          });
          $.selectedCamera = $.videoDeviceContainer[0];
        }
      });
    }
  }
};
</script>
<style scoped>
#setting-info {
  position: relative;
  margin-top: 5px;
  cursor: pointer;
}

#setting-info .tooltip-text {
  visibility: hidden;
  width: 370px;
  padding: 10px;
  text-align: center;
  border-radius: 6px;
  position: absolute;
  left: -10px;
  top: -130px;
  z-index: 1;
}
.tooltip-text{
  margin-top: -55px;
}
#setting-info:hover .tooltip-text {
  visibility: visible;
}



</style>

